module.exports = "/packs/she_fukidashi-69b8db4c67a13e18ec4ea75c3ae8c6b8.png";